import React, { useState } from "react";
import { toast } from "sonner";
import { finApi, finErr } from "@/lib/financeApi";
import { btn, btnGold, btnGreen, btnRed } from "@/components/nds/windows/finance/parts";
import { InlineAction } from "@/components/nds/windows/finance/recordParts";
import { useIsSuper } from "@/components/nds/windows/finance/InvoiceActions";

const OPEN = ["current", "partial", "overdue"];

/** SA-only: Record payment · Edit amount (before any payment) · Waive (note) · Void (note). */
export default function ObligationActions({ cfg, rec, onChanged }) {
  const isSuper = useIsSuper();
  const [mode, setMode] = useState(null);
  const [busy, setBusy] = useState(false);
  const id = `${cfg.testid}-${rec.id}`;
  const run = async (fn, msg) => {
    setBusy(true);
    try { await fn(); toast.success(msg); setMode(null); onChanged(); }
    catch (e) { toast.error(finErr(e)); } finally { setBusy(false); }
  };
  if (!isSuper || rec.status === "voided") return null;
  const base = `${cfg.api}/${rec.id}`;
  const modes = {
    pay: { numeric: true, ph: `Amount (balance ${rec.balance_due})`, cls: btnGreen, go: (v) => run(() => finApi.post(`${base}/payments`, { amount: Number(v) }), "Payment posted to ledger") },
    amount: { numeric: true, ph: `New amount due (now ${rec.amount_due})`, cls: btnGold, go: (v) => run(() => finApi.patch(`${base}/amount`, { amount_due: Number(v) }), "Amount updated") },
    waive: { ph: "Waive reason (required)", cls: `${btn} border-white/20 text-nex-silver`, go: (v) => run(() => finApi.patch(`${base}/waive`, { note: v }), "Balance waived") },
    void: { ph: "Void reason (required)", cls: btnRed, go: (v) => run(() => finApi.patch(`${base}/void`, { note: v }), "Record voided") },
  };
  if (mode) {
    const m = modes[mode];
    return <InlineAction id={id} mode={mode} numeric={m.numeric} placeholder={m.ph} confirmClass={m.cls} busy={busy} onConfirm={m.go} onCancel={() => setMode(null)} />;
  }
  const open = OPEN.includes(rec.status);
  const B = (k, label, cls, show) => show && (
    <button type="button" onClick={(e) => { e.stopPropagation(); setMode(k); }} data-testid={`${id}-${k}`} className={cls}>{label}</button>
  );
  return (
    <div className="flex flex-wrap gap-2">
      {B("pay", "Record payment", btnGreen, open && rec.balance_due > 0)}
      {B("amount", "Edit amount", btnGold, ["current", "overdue"].includes(rec.status) && rec.amount_paid === 0)}
      {B("waive", "Waive", `${btn} border-white/20 text-nex-silver hover:bg-white/5`, open && rec.balance_due > 0)}
      {B("void", "Void", btnRed, true)}
    </div>
  );
}
